import React from 'react';
import { Form, Input, Button,Select,Spin } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var sacco= ''
var token= ''

class MemberTypeForm extends React.Component {

  state = {
    type_name:'',
    minimum_savings_balance:0,
    deposit_charges:0,
    minimum_account_deposit:0,
    savings_withdraw_charges:0,
    withdrawals_per_month:0,
    account_fine_fee:0,
    account_transfer_charge:0,
    account_monthly_charge:0,
    account_monthly_interest_rate:0,
    account_statement_fee:0,
    cheque_deposit_fee:0,
    reactivation_charge:0,

    account_monthly_interest_rate:0,
    minimum_accnt_bal_forintrest:0,
    minimum_age:0,

  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }
    


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({datarequested:false})
}


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('type_name', this.state.type_name);
    form_data.append('minimum_savings_balance', this.state.minimum_savings_balance);
    form_data.append('deposit_charges', this.state.deposit_charges);
    form_data.append('minimum_account_deposit', this.state.minimum_account_deposit);
    form_data.append('savings_withdraw_charges', this.state.savings_withdraw_charges);
    form_data.append('sacco', sacco);

    form_data.append('account_monthly_interest_rate', this.state.account_monthly_interest_rate);
    form_data.append('minimum_accnt_bal_forintrest', this.state.minimum_accnt_bal_forintrest);
    form_data.append('minimum_age', this.state.minimum_age);


    axios.post(serverconfig.backendserverurl+'/api/membertypes/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>         this.setState({datarequested:false})
,  window.location.reload(false)
  )
  .catch(error => console.log(error))

  }


  handletype_nameChange= (e) => this.setState({ type_name: e.target.value});
  handleminimum_savings_balanceChange= (e) => this.setState({ minimum_savings_balance: e.target.value});
  handledeposit_chargesChange= (e) => this.setState({ deposit_charges: e.target.value});
  handleminimum_account_depositChange= (e) => this.setState({ minimum_account_deposit: e.target.value});
  handlesavings_withdraw_chargesChange= (e) => this.setState({ savings_withdraw_charges: e.target.value});
  handlewithdrawals_per_monthChange= (e) => this.setState({ withdrawals_per_month: e.target.value});
  handleaccount_fine_feeChange= (e) => this.setState({ account_fine_fee: e.target.value});
  handleaccount_transfer_chargeChange= (e) => this.setState({ account_transfer_charge: e.target.value});
  handleaccount_monthly_chargeChange= (e) => this.setState({ account_monthly_charge: e.target.value});
  handleaccount_monthly_interest_rateChange= (e) => this.setState({ account_monthly_interest_rate: e.target.value});
  handleaccount_statement_feeChange= (e) => this.setState({ account_statement_fee: e.target.value});
  handlecheque_deposit_feeChange= (e) => this.setState({ cheque_deposit_fee: e.target.value});


  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      return (
        <div>
          <Form
            onFinish={(event) => this.handleFormSubmit(event)} 
          >
            <FormItem label="Type Name"
              name="type_name"
              rules={[
                {
                  required: true,
                  message: 'Please enter name',
                },
              ]}             
            >
              <Input name="type_name"  placeholder="Put a name here." value={this.state.type_name} onChange={this.handletype_nameChange} />
            </FormItem>

            <FormItem label="Minimum Savings Balance"
              name="minimum_savings_balance"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="minimum_savings_balance"  placeholder="0.00" value={this.state.minimum_savings_balance} onChange={this.handleminimum_savings_balanceChange} />
            </FormItem>
  
            <FormItem label="Deposit Charges"
              name="deposit_charges"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="deposit_charges"  placeholder="0.00" value={this.state.deposit_charges} onChange={this.handledeposit_chargesChange} />
            </FormItem>
  
            <FormItem label="Minimum Account Deposit"
              name="minimum_account_deposit"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="minimum_account_deposit"  placeholder="0.00" value={this.state.minimum_account_deposit} onChange={this.handleminimum_account_depositChange} />
            </FormItem>


            <FormItem label="Savings Withdraw Charges"
              name="savings_withdraw_charges"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="savings_withdraw_charges"  placeholder="0.00" value={this.state.savings_withdraw_charges} onChange={this.handlesavings_withdraw_chargesChange} />
            </FormItem>

            <FormItem label="Savings annual interest rate"
              name="account_monthly_interest_rate"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="account_monthly_interest_rate"  placeholder="0.00" value={this.state.account_monthly_interest_rate} onChange={(val)=>{this.setState({account_monthly_interest_rate:val.target.value})}} />
            </FormItem>

            <FormItem label="Minimum savings accnt_bal for intrest"
              name="minimum_accnt_bal_forintrest"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="minimum_accnt_bal_forintrest"  placeholder="0.00" value={this.state.minimum_accnt_bal_forintrest} onChange={(val)=>{this.setState({minimum_accnt_bal_forintrest:val.target.value})}} />
            </FormItem>


            <FormItem label="Minimum member age"
              name="minimum_age"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="minimum_age"  placeholder="0.00" value={this.state.minimum_age} onChange={(val)=>{this.setState({minimum_age:val.target.value})}} />
            </FormItem>


            <FormItem>
              <Button  type="primary" htmlType="submit">Create</Button>
            </FormItem>
          </Form>
        </div>
      );


    }


    
  }

}


export default MemberTypeForm;



